import { Object } from '@common/Object/Object'
import DOM from '@common/DOM/DOM'

export const NAV_EVENT = 'Navigate'

// Az Activator komponensben is hozzá kell addnod a kezelési résznél!
export enum ENavigator {
  Welcome    = 'welcome',
  Licence    = 'licence',
  Activate   = 'activate',
  Start      = 'start',
  Congrats   = 'congrats',
  Demo       = 'demo',
  Deactivate = 'deactivate'
}

type TNavigator = {
  readonly [key in ENavigator]: TVoidCallback
}

/**
 * Az aktivátoron belüli navigálás.
 * @param detail - Hova navigálunk?
 */
function navigate (detail: ENavigator): void {
  DOM.dispatch(document, NAV_EVENT, false, detail) // boolean-t ad vissza, ezért kell a function body
}

const navigator = Object.getValues(ENavigator).reduce((acc: TUnknownObject, curr) => {
  acc[curr] = function nav (): void {
    navigate(curr)
  }

  return acc
}, {}) as TNavigator

export { navigator }
